import app from 'flarum/forum/app';
import { staffQuery } from './staffGroups';
import { onlineQuery } from '../query/OnlineGambit';

/**
 * Which of the "Membres" menu's lists (addMembersMenu.tsx) the page shows:
 * all three are the member list, /users, told apart by the search their
 * link sets - "est:en-ligne", "groupe:1,4", or none. Null away from the
 * member list.
 *
 * For the menu's current link (core's LinkButton compares the path alone,
 * which all three share) and the page's title (addMemberList.tsx).
 */
export function memberListView() {
  if (!('fof_user_directory' in app.routes) || m.route.get()?.split('?')[0] !== app.route('fof_user_directory')) {
    return null;
  }
  const words = String(m.route.param('q') || '').split(/\s+/);
  if (words.includes(onlineQuery())) return 'online';
  if (words.includes(staffQuery())) return 'team';
  return 'members';
}

/**
 * The page's title for the online members and the team - null for the
 * whole list, which keeps fof/user-directory's own ("Liste des membres").
 */
export function memberListTitle() {
  const view = memberListView();
  if (view === 'online') return app.translator.trans('champis-users.forum.members_menu.online_link', {}, true);
  if (view === 'team') return app.translator.trans('champis-users.forum.members_menu.team_link', {}, true);
  return null;
}
flarum.reg.add('champis-users', 'forum/utils/memberListView', { memberListView: memberListView,memberListTitle: memberListTitle, });